import { Typography } from '@musinsa/mds';

export const EmptyShopCurationList = () => (
  <div className="flex flex-1 px-4 py-10 flex-col justify-center items-center bg-gray-100">
    <Typography variant="body14pxMed">등록된 큐레이션이 없습니다.</Typography>
  </div>
);
